export const TRIGGER_VIDEO = 'MediaContextTypes.TRIGGER_VIDEO'
export const INTRO_VIDEO = 'MediaContextTypes.INTRO_VIDEO'

export default {
    TRIGGER_VIDEO,
    INTRO_VIDEO,
}
